module.exports = __webpack_public_path__ + "media/images/choose/courses_student-188f90f07774a9f9ab6cf3dd9d9f681d.png";